import React from 'react';
import { INSURANCE_TYPES } from 'mock';

function InsuranceList({ insurance }) {
  const items = Array.isArray(insurance) ? insurance : [];

  const formatAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '—';
    const num = Number(amount);
    if (Number.isNaN(num)) return `£${amount}`;
    return `£${num.toLocaleString('en-GB')}`;
  };

  return (
    <div className='flex flex-col gap-[17px]'>
      <div className='flex flex-column'>
        <p className='text-gray3 font-bold text-[15px]'>Insurance</p>
        <p className='text-gray3 font-[400] text-[15px]'>
          Insurance policies held along with coverage amounts
        </p>
      </div>
      {items.length === 0 ? (
        <p className='text-sm text-gray3 italic'>
          No insurance policies added yet
        </p>
      ) : (
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4'>
          {items.map(({ insuranceType, amount }) => {
            const match = INSURANCE_TYPES?.find(
              (i) =>
                i.name.toLowerCase() === (insuranceType || '').toLowerCase()
            );
            const label = match ? match.title : insuranceType;
            return (
              <div
                key={insuranceType}
                className='relative overflow-hidden flex flex-col gap-1 bg-lightGreen rounded-[12px] pl-5 pr-4 py-4 shadow-light'
              >
                <span className='absolute left-0 top-0 h-full w-[4px] bg-primary' />
                <p className='text-xs text-darkGray2 font-[600] uppercase tracking-wider'>
                  {label}
                </p>
                <p className='text-[22px] leading-tight text-primaryDark font-[700]'>
                  {formatAmount(amount)}
                </p>
                <p className='text-[11px] text-gray3 font-[400]'>
                  Coverage amount
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export { InsuranceList };
